<div class="bg-col-w">
    <div class="wrap p-t p-b">
        <ng-content></ng-content>
    </div>
</div>